import { db } from "common/config/Firebase"
import addTaskToInvoiceDetail from "./detail/addTaskToInvoiceDetail"
import BusEvent from "common/services/BusEvent"

const invoicesCollection = db.collection('invoices')

const addInvoiceUseCase = async (invoice, isProforma) => {
    if (invoice.paymentMode === undefined || invoice.paymentMode === null || invoice.paymentMode === "") {
        invoice.paymentMode = 2
    }

    if (isProforma) {
        invoice.type = "Proforma"
    }

    const cleanInvoice = Object.fromEntries(
        Object.entries({ ...invoice, invoiceDate: new Date().getTime() })
            .filter(([, v]) => v !== undefined)
    )

    const { id } = await invoicesCollection.add(cleanInvoice)
    
    if (invoice.newTask) {
        await addTaskToInvoiceDetail(id, invoice.ivaPercent, invoice.taskReference)
        invoice.newTask = false
    }

    BusEvent.publish(BusEvent.NEW_INVOICE, invoice)

    return id
}

export default addInvoiceUseCase